"use strict";
/*
 * Get useful hostnames for atms-web-ui / web / etc.
 *
 * Used by:
 *  - the app for redirect/embedding logic
 *  - the local proxy for atms-web-ui <=> web happiness in local/docker development
 */
Object.defineProperty(exports, "__esModule", { value: true });
const frontendApps_1 = require("./frontendApps");
exports.default = (host = window.location.hostname, port = window.location.port) => {
    // the current app could be running on something like some-web-ui.local.atms.a2z.com;
    // figure out the base domain
    const knownBaseHostPattern = /(((local|dev|beta2|staging|load)\.)?atms\.a2z\.com)$/;
    const knownHostMatch = knownBaseHostPattern.exec(host);
    const BASE_HOST = knownHostMatch ? knownHostMatch[1] : 'local.atms.a2z.com';
    let portSuffix = '';
    // if developing atms-web-ui, preserve the port so everything goes through its reverse proxy;
    // this way you can also run/use atms-web-service, web, etc outside of docker too
    if (frontendApps_1.isOnAtmsWebUi() && port) {
        portSuffix = port ? `:${port}` : '';
    }
    // otherwise use the default port so that we actually hit those services (real or dockerized);
    // for prod this makes sense (as there's no non-standard port), and this is also necessary when
    // developing other *-web-ui apps locally -- they don't have a reverse proxy to send things to
    // web, etc., so we need to be able to hit/redirect directly to those services
    return {
        // common domain for cookies (e.g. local.atms.a2z.com)
        BASE_HOST,
        // where top-level unembedded old-style web lives
        WEB_HOST_AND_PORT: `web.${BASE_HOST}${portSuffix}`,
        ATMS_BFF_HOST_AND_PORT: `atmsapi.${BASE_HOST}${portSuffix}`,
    };
};
//# sourceMappingURL=getAppHostConfig.js.map